import { t } from "@lingui/macro";
import * as React from "react";
import { G, Rect, Path, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const FitnessIcon = (props: IconProps) => {
  const clipPathId = React.useId();

  return (
    <Icon
      fill="none"
      viewBox="0 0 16 16"
      color="#001A19"
      title={t`Fitness`}
      {...props}
    >
      <G clipPath={`url(#${clipPathId})`}>
        <Rect
          width={3.176}
          height={9.881}
          x={0.717}
          y={8.222}
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth={1.5}
          rx={1.588}
          transform="rotate(-45 .717 8.222)"
          fill="none"
        />
        <Rect
          width={3.176}
          height={9.881}
          x={6.05}
          y={2.889}
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth={1.5}
          rx={1.588}
          transform="rotate(-45 6.05 2.889)"
          fill="none"
        />
        <Rect
          width={2.338}
          height={4.852}
          x={10.199}
          y={2.296}
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth={1.5}
          rx={1.169}
          transform="rotate(-45 10.199 2.296)"
          fill="none"
        />
        <Rect
          width={2.338}
          height={4.852}
          x={0.717}
          y={11.778}
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth={1.5}
          rx={1.169}
          transform="rotate(-45 .717 11.778)"
          fill="none"
        />
        <Path
          fill="currentColor"
          d="M5.983 8.758 8.832 5.91l1.185 1.185-2.848 2.848z"
        />
      </G>
      <Defs>
        <ClipPath id={clipPathId}>
          <Path fill="#fff" d="M0 0h16v16H0z" />
        </ClipPath>
      </Defs>
    </Icon>
  );
};
